export const DASHBOARD_PATH = '/?module=dashboard';
export const LOGIN_PATH = '/login';
